var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIkonerNavigationEngelska = function SvgIkonerNavigationEngelska(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#00263E",
    strokeWidth: 1.5,
    d: "m6.937 16.763 2.112-2.113H14a3.25 3.25 0 0 0 3.25-3.25V5A3.25 3.25 0 0 0 14 1.75H4A3.25 3.25 0 0 0 .75 5v6.4A3.25 3.25 0 0 0 4 14.65h2.51v1.936a.25.25 0 0 0 .427.177z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00263E",
    d: "m4.9 8.808.911-.088q.082.458.334.674.252.215.679.215.452 0 .682-.191.23-.192.23-.448a.42.42 0 0 0-.097-.28q-.097-.115-.337-.201-.165-.057-.75-.203-.753-.186-1.057-.458a1.2 1.2 0 0 1-.427-.934 1.2 1.2 0 0 1 .2-.663q.202-.308.58-.47A2.3 2.3 0 0 1 6.76 5.6q.873 0 1.314.383t.464 1.022l-.937.041q-.06-.357-.258-.514t-.593-.157q-.408 0-.64.168a.34.34 0 0 0-.148.288q0 .165.14.281.177.15.86.31.684.162 1.011.334a1.3 1.3 0 0 1 .513.472q.185.299.185.739a1.37 1.37 0 0 1-.848 1.264q-.405.17-1.01.169-.879 0-1.35-.407-.473-.406-.564-1.185zm4.562 1.51V5.679h3.44v.785h-2.503v1.028h2.329v.782h-2.33v1.262h2.592v.782z"
  }))));
};
export default SvgIkonerNavigationEngelska;